import theme, { createStyles } from 'core/utilities/theme';

export default createStyles({
  line: {
    position: 'absolute',
    zIndex: -1,
    top: 0,
    right: 0,
    bottom: 0,
    left: '50%',
    height: '100vh',
    borderLeft: `1px dotted ${theme.palette.text.primary}`,
  },
});
